import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import {GysTahsilAnaControlService} from "../ctl-gys-tahsil-ana.service";


@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private gysTahsilAnaControlService : GysTahsilAnaControlService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
            ]);

            const filterArr = [];
            if (this.gysTahsilAnaControlService.belediyeCode) filterArr.push(['BelediyeKod', '=', this.gysTahsilAnaControlService.belediyeCode]);
            if (this.gysTahsilAnaControlService.kisiKod) filterArr.push(['KisiKod', '=', this.gysTahsilAnaControlService.kisiKod]);
            if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
